module.exports = __webpack_public_path__ + "img/4.344f647b.svg";